import { render, staticRenderFns } from "./ChatKqReportDialog.vue?vue&type=template&id=4f4a3594&scoped=true"
import script from "./ChatKqReportDialog.vue?vue&type=script&lang=js"
export * from "./ChatKqReportDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatKqReportDialog.vue?vue&type=style&index=0&id=4f4a3594&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4a3594",
  null
  
)

export default component.exports